import styled from 'styled-components';
import {getToken, getSpacing} from '@tickchak/react-share/app';
import {dFlexCenter} from '../../../../globalVariables/GlobalFlex';

export const button = styled.div`
    ${dFlexCenter};
    width: 100%;
    gap: ${getSpacing('spaceSm')};
    padding: ${getSpacing('spaceMd')} 0;
    border-bottom: 1px solid ${getToken('color.border.subtle')};
    cursor: pointer;
    &:last-child {
        border-bottom: none;
    }
`;
